import { render, staticRenderFns } from "./validationtask-completion-modal.vue?vue&type=template&id=fe7d52d0&scoped=true"
import script from "./validationtask-completion-modal.vue?vue&type=script&lang=js"
export * from "./validationtask-completion-modal.vue?vue&type=script&lang=js"
import style0 from "./validationtask-completion-modal.vue?vue&type=style&index=0&id=fe7d52d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7d52d0",
  null
  
)

export default component.exports